import { FC } from "react";
import { List, ListItem } from "@mui/material";
import { gameState } from "@/services/gameState";
import EventCard from "./EventCard";
import { isVisibleActionType } from "./event-history-utils";
import { useActionBookmarksContext } from "@context/ActionBookmarksContext";
import { GameProgress } from "@/models/gameState";
import { useGameDataContext } from "@context/GameDataContext";
import RenderIfVisible from "../RenderIfVisible";

const GameEventLog: FC<{
  variant?: "wide" | "narrow";
  filterBookmarks?: boolean;
}> = ({ variant = "wide", filterBookmarks = false }) => {
  return (
    <List
      sx={{
        width: "100%",
        maxHeight: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        p: 0,
      }}
    >
      <EventHistoryList variant={variant} filterBookmarks={filterBookmarks} />
    </List>
  );
};

const EventHistoryList: FC<{
  variant: "wide" | "narrow";
  filterBookmarks: boolean;
}> = ({ variant, filterBookmarks }) => {
  const actionHistory = gameState("actionHistory");
  const gameProgress = gameState("gameProgress");
  const { game } = useGameDataContext();
  const { actionBookmarks } = useActionBookmarksContext();

  const showDurationSinceGameStart =
    gameProgress >= GameProgress.GAME_FINALIZED;

  return Object.values(actionHistory)
    ?.filter(
      ({ type, hideFromHistory, orderRank }) =>
        isVisibleActionType(type) &&
        !hideFromHistory &&
        (!filterBookmarks || actionBookmarks.includes(orderRank)),
    )
    .reverse()
    .map((action) => {
      const key = `action-${action.uuid}`;
      return (
        <RenderIfVisible
          visibleOffset={500}
          defaultHeight={
            showDurationSinceGameStart
              ? game?.gameData.gameStartVideoOffset
                ? 104
                : 85
              : 65
          }
          stayRendered={true}
          key={key}
        >
          <ListItem
            sx={{
              gap: 1,
              ...(action.isUndone ? { opacity: 0.7 } : {}),
              paddingLeft: 1,
            }}
            alignItems="center"
            divider
            key={`${key}-list-item`}
          >
            <EventCard
              action={action}
              variant={variant}
              showDurationSinceGameStart={showDurationSinceGameStart}
              bookmarksFilterActive={filterBookmarks}
            />
          </ListItem>
        </RenderIfVisible>
      );
    });
};

export default GameEventLog;
